import { createRouter, createWebHashHistory } from "vue-router";
import HomePage from "../views/HomePage.vue";
import main from "../views/index.vue";

const router = createRouter({
  history: createWebHashHistory(import.meta.env.BASE_URL),
  routes: [
      {
        path: "/",
        name: "home",
        component: HomePage,
        meta: { requiresAuth: false }
      },
      {
        path: "/main",
        name: "main",
        component: main,
        meta: { requiresAuth: false }
      },
  ],
});

const whiteList = ['/login', '/', '/main']

router.beforeEach(async (to, from, next) => {
    const isLoggedIn = checkLoginStatus()
    console.log('isLoggedIn:', isLoggedIn)
    
    if (to.meta.requiresAuth) {
        if (isLoggedIn) {
            next()
        } else {
            next({
                path: '/login',
                query: { redirect: to.fullPath }
            })
        }
        return
    }

    next()
})

const checkLoginStatus = () => {
    const token = localStorage.getItem('jwt')
    const expiredAt = localStorage.getItem('jwtExpiredAt')

    if (!token || token === 'undefined' || !expiredAt || expiredAt === 'undefined') {
        return false
    }
    const now = Date.now()
    const expireTime = parseInt(expiredAt) * 1000
    const timeLeft = expireTime - now

    if (timeLeft > 0 && timeLeft < 5 * 60 * 1000) {
        console.log('token 即将过期，跳转到登录页')
        return false
    } else if (timeLeft <= 0) {
        console.log('token 已过期，跳转到登录页')
        return false
    } else {
        console.log('token 有效，跳转到详情页')
        return true
    }
}

export default router;
